import DatePicker from "legacy/DatePicker"
import FormGroup from "legacy/FormGroup"
import ReactValidator from "legacy/ReactValidator.es6"
import NextButton from "legacy/boater-reservation-flow/NextButton"
import { afterSetState, isset, numbersOnly } from "legacy/helpers.es6"
import WaitlistContact from "legacy/waitlist/WaitlistContact"
import WaitlistContactsTable from "legacy/waitlist/WaitlistContactsTable"
import moment from "moment"
import PropTypes from "prop-types"
import React from "react"

// Note: jQuery ($) and $context are loaded globally

class WaitlistController extends React.Component {
  constructor(args) {
    super(args)
    this.boaterSide = !!this.props.boaterSide
    this.state = {
      activeContacts: [],
      archivedContacts: [],
      selectedContact: null,
      selectedContactBoat: null,
      name: "",
      email: "",
      phone: "",
      lengthOverall: this.props.lengthOverall,
      beam: "",
      boatType: "power",
      emailMarketing: true,
      draft: "",
      height: "",
      boatName: "",
      specialRequest: "",

      loadingContacts: false,
      loadingBoats: false,
      processing: false,

      firstDay: this.props.firstDay,
      lastDay: this.props.lastDay,
      spaceType: this.props.spaceType.toLowerCase(),
      verticalConstraints: this.props.verticalConstraints,
      draftMissing: true,
      heightMissing: true,
      errors: {},
    }
    if (this.boaterSide) {
      if (this.props.state.userId) {
        this.state.contactBoats = this.props.state.userBoats
        this.state.selectedContact = {
          id: this.props.state.userId,
          name: this.props.state.fullName,
        }
      }
      if (this.props.state.loa) {
        this.state.lengthOverall = this.props.state.loa
      }
    }
    this.canSubmitDraw = true
    this.canSubmitHeight = true

    // Create refs for height and draft inputs
    this.heightInputRef = React.createRef()
    this.draftInputRef = React.createRef()

    this.validator = new ReactValidator()

    this.isContactSelected = this.isContactSelected.bind(this)
    this.isContactBoatSelected = this.isContactBoatSelected.bind(this)
    this.filterContacts = this.filterContacts.bind(this)
    this.findContactBoat = this.findContactBoat.bind(this)
    this.selectContact = this.selectContact.bind(this)
    this.selectContactBoat = this.selectContactBoat.bind(this)
    this.changed = this.changed.bind(this)
    this.columnSize = this.columnSize.bind(this)
    this.lengthOverall = this.lengthOverall.bind(this)
    this.submit = this.submit.bind(this)
    this.postUrl = this.postUrl.bind(this)
    this.requireVerticalConstraints = this.requireVerticalConstraints.bind(this)
    this.verticalSection = this.verticalSection.bind(this)
    this.toggleEmailMarketing = this.toggleEmailMarketing.bind(this)
    this.handleDrawChange = this.handleDrawChange.bind(this)
    this.handleHeightChange = this.handleHeightChange.bind(this)
    this.contactsTable = this.contactsTable.bind(this)
    this.renderEmailMarketing = this.renderEmailMarketing.bind(this)
    this.showSpaceType = this.showSpaceType.bind(this)
    this.renderValidationError = this.renderValidationError.bind(this)
    this.handleDatePickerFirstDay = this.handleDatePickerFirstDay.bind(this)
    this.handleDatePickerLastDay = this.handleDatePickerLastDay.bind(this)
    this.handleChangedEvent = this.handleChangedEvent.bind(this)
  }

  componentDidMount() {
    if (this.boaterSide) {
      this.props.setHeader("Waitlist")
      if (isset(this.props.state.boatId)) {
        const contactBoats = this.state.contactBoats || []
        const boat = contactBoats.find(
          (boat) => boat.id === Number(this.props.state.boatId)
        )
        this.selectContactBoat(boat)
      }
    }
  }

  isContactSelected(contact) {
    return (
      this.state.selectedContact && this.state.selectedContact.id === contact.id
    )
  }

  isContactBoatSelected(boat) {
    return (
      this.state.selectedContactBoat &&
      this.state.selectedContactBoat.id === boat.id
    )
  }

  filterContacts() {
    if (this.boaterSide) return
    if (
      (this.state.name.trim().length >= 3 ||
        this.state.email.trim().length >= 3 ||
        this.state.phone.trim().length >= 3) &&
      !this.state.selectedContact
    ) {
      // Note: jQuery ($) is loaded globally
      $.post(
        "/manage/" + this.props.marinaSlug + "/waitlists/contacts",
        {
          name: this.state.name.trim(),
          email: this.state.email.trim(),
          phone: this.state.phone.trim(),
        },
        (data) => {
          this.setState({
            activeContacts: data.activeContacts,
            archivedContacts: data.archivedContacts,
            archivedContactsPath: data.archivedContactsPath,
            loadingContacts: false,
          })
        }
      )
      this.setState({ loadingContacts: true })
    } else {
      this.setState({ activeContacts: [], archivedContacts: [] })
    }
  }

  findContactBoat() {
    if (this.state.selectedContact) {
      // Note: jQuery ($) is loaded globally
      $.post(
        "/manage/" + this.props.marinaSlug + "/waitlists/contact_boats",
        { contact_id: this.state.selectedContact.id },
        (data) => {
          this.setState({
            contactBoats: data,
            loadingBoats: false,
          })
          if (data.length > 0) {
            this.selectContactBoat(data[0])
          }
        }
      )
      this.setState({ loadingBoats: true })
    }
  }

  selectContact(contact) {
    if (this.isContactSelected(contact)) {
      this.setState({
        selectedContact: null,
        selectedContactBoat: null,
        contactBoats: null,
      })
    } else {
      this.setState({
        selectedContact: contact,
        selectedContactBoat: null,
        contactBoats: null,
      })
    }
    afterSetState(() => this.findContactBoat())
  }

  selectContactBoat(boat) {
    if (boat) {
      this.setState({ draftMissing: !boat.draft, heightMissing: !boat.height })
    }
    this.setState({ selectedContactBoat: boat })
  }

  changed(event) {
    const target = event.target
    const value = target.type === "checkbox" ? target.checked : target.value
    const name = target.name

    this.setState({
      [name]: value,
    })
    if (["name", "email", "phone"].includes(name)) {
      afterSetState(() => this.filterContacts())
    }
  }

  columnSize() {
    if (this.requireVerticalConstraints()) {
      return "col-sm-4"
    }
    return "col-sm-6"
  }

  lengthOverall() {
    this.validator.message("boat_name", "true", "required")
    this.validator.message("length_overall", "true", "required")
    this.validator.message("boat_type", "true", "required")
    this.validator.message("beam", "true", "required")
    if (!this.state.selectedContactBoat) {
      return (
        <div>
          <div className="row nested-row">
            <div className={this.columnSize()}>
              <div className="form-group">
                <label htmlFor="boatName">Boat Name</label>
                <input
                  id="boatName"
                  className="form-control"
                  name="boatName"
                  onChange={this.handleChangedEvent}
                  value={this.state.boatName}
                  autoFocus
                />
                {this.validator.message(
                  "boat_name",
                  this.state.boatName,
                  "required"
                )}
              </div>
            </div>
            <div className={this.columnSize()}>
              <div className="form-group">
                <label htmlFor="boatType">Boat Type</label>
                <select
                  id="boatType"
                  className="form-control"
                  name="boatType"
                  value={this.state.boatType}
                  onChange={this.handleChangedEvent}
                >
                  <option value="power">Power Boat</option>
                  <option value="sail">Sailboat</option>
                </select>
                {this.validator.message(
                  "boat_type",
                  this.state.boatType,
                  "required"
                )}
              </div>
            </div>
            <div className={this.columnSize()}>
              <div className="form-group">
                <label htmlFor="lengthOverall">Length Overall</label>
                <div className="form-control-with-icon">
                  <span className="form-control-icon-right">ft</span>
                  <input
                    type="text"
                    id="lengthOverall"
                    className="form-control"
                    name="lengthOverall"
                    value={this.state.lengthOverall}
                    onChange={this.handleChangedEvent}
                  />
                </div>
                {this.validator.message(
                  "length_overall",
                  this.state.lengthOverall,
                  "required"
                )}
              </div>
            </div>
            <div className={this.columnSize()}>
              <div className="form-group">
                <label htmlFor="beam">Beam</label>
                <div className="form-control-with-icon">
                  <span className="form-control-icon-right">ft</span>
                  <input
                    id="beam"
                    className="form-control"
                    name="beam"
                    onChange={this.handleChangedEvent}
                    value={this.state.beam}
                  />
                </div>
                {this.validator.message("beam", this.state.beam, "required")}
              </div>
            </div>
            {this.verticalSection()}
          </div>
          <hr />
        </div>
      )
    }
  }

  submit() {
    this.validator.displayErrors()
    this.forceUpdate()
    if (this.requireVerticalConstraints()) {
      if (!this.state.draft) {
        this.handleDrawChange({ target: { value: "" } })
      }
      if (!this.state.height) {
        this.handleHeightChange({ target: { value: "" } })
      }
    }
    if (
      this.validator.allValid() &&
      (this.state.selectedContactBoat ||
        (this.canSubmitHeight && this.canSubmitDraw))
    ) {
      this.setState({ processing: true })
      const formData = {
        name:
          this.boaterSide && isset(this.props.user.fullName)
            ? this.props.user.fullName
            : this.state.name,
        email:
          this.boaterSide && isset(this.props.user.email)
            ? this.props.user.email
            : this.state.email,
        phone:
          this.boaterSide && isset(this.props.user.phone)
            ? this.props.user.phone
            : this.state.phone,
        length_overall: this.state.lengthOverall,
        draw: this.state.draft,
        height: this.state.height,
        beam: this.state.beam,
        boat_type: this.state.boatType,
        boat_name: this.state.boatName,
        first_day: this.state.firstDay,
        last_day: this.state.lastDay,
        special_request: this.state.specialRequest,
        space_type: this.state.spaceType,
        hubspot_sync: this.state.emailMarketing,
      }
      if (this.state.selectedContact) {
        this.boaterSide
          ? (formData.user_id = this.state.selectedContact.id)
          : (formData.contact_id = this.state.selectedContact.id)
      }
      if (this.state.selectedContactBoat) {
        this.boaterSide
          ? (formData.boat_id = this.state.selectedContactBoat.id)
          : (formData.contact_boat_id = this.state.selectedContactBoat.id)
      }
      // Note: jQuery ($) is loaded globally
      $.post(this.postUrl(), formData, (data) => {
        window.location.href = data.redirect_to
      }).fail((data) => {
        const parsedData = JSON.parse(data.responseText)
        this.setState({
          validationMessage: parsedData.error,
          invalidEmailUrl: parsedData.link,
          processing: false,
        })
      })
    }
  }

  postUrl() {
    return this.boaterSide
      ? "/explore/destination/" +
          this.props.state.marinaSlug +
          "/waitlists/short_term/entries"
      : "/manage/" + this.props.marinaSlug + "/waitlists/short_term"
  }

  requireVerticalConstraints() {
    return (
      (this.state.draftMissing || this.state.heightMissing) &&
      (this.state.verticalConstraints.height ||
        (this.state.verticalConstraints.depth &&
          this.state.verticalConstraints.depth <= 15))
    )
  }

  verticalSection() {
    if (this.requireVerticalConstraints()) {
      return (
        <div>
          <div className="col-sm-4">
            <div className="form-group">
              <label htmlFor="height">Height</label>
              <div className="form-control-with-icon">
                <span className="form-control-icon-right">ft</span>
                <input
                  type="text"
                  id="height"
                  className="form-control"
                  value={this.state.height}
                  onChange={this.handleHeightChange}
                  ref={this.heightInputRef}
                />
                {this.validator.customMessage(this.state.errors.height, "mb-3")}
              </div>
            </div>
          </div>
          <div className="col-sm-4">
            <div className="form-group">
              <label htmlFor="draft">Draft</label>
              <div className="form-control-with-icon">
                <span className="form-control-icon-right">ft</span>
                <input
                  type="text"
                  id="draft"
                  className="form-control"
                  value={this.state.draft}
                  onChange={this.handleDrawChange}
                  ref={this.draftInputRef}
                />
                {this.validator.customMessage(this.state.errors.draft, "mb-3")}
              </div>
            </div>
          </div>
        </div>
      )
    }
  }

  toggleEmailMarketing(event) {
    event.target.checked
      ? this.setState({ emailMarketing: true })
      : this.setState({ emailMarketing: false })
  }

  handleDrawChange(event) {
    this.setState({ draft: numbersOnly(event.target.value) })

    if (
      this.state.verticalConstraints.depth &&
      this.state.verticalConstraints.depth < numbersOnly(event.target.value)
    ) {
      this.setState({
        errors: {
          ...this.state.errors,
          draft: `This marina supports a maximum draft of ${this.state.verticalConstraints.depth} feet.`,
        },
      })
      this.canSubmitDraw = false
    } else if (!event.target.value) {
      this.setState({
        errors: { ...this.state.errors, draft: "This field is required." },
      })
      this.canSubmitDraw = false
    } else {
      this.setState({ errors: { ...this.state.errors, draft: null } })
      this.canSubmitDraw = true
    }
  }

  handleHeightChange(event) {
    this.setState({ height: numbersOnly(event.target.value) })

    if (
      this.state.verticalConstraints.height &&
      this.state.verticalConstraints.height < numbersOnly(event.target.value)
    ) {
      this.setState({
        errors: {
          ...this.state.errors,
          height: `This marina supports a maximum clearance of ${this.state.verticalConstraints.height} feet.`,
        },
      })
      this.canSubmitHeight = false
    } else if (!event.target.value) {
      this.setState({
        errors: { ...this.state.errors, height: "This field is required." },
      })
      this.canSubmitHeight = false
    } else {
      this.setState({ errors: { ...this.state.errors, height: null } })
      this.canSubmitHeight = true
    }
  }

  handleDatePickerFirstDay(firstDay) {
    this.setState({ firstDay })
  }

  handleDatePickerLastDay(lastDay) {
    this.setState({ lastDay })
  }

  handleChangedEvent(e) {
    this.changed(e)
  }

  contactsTable() {
    if (this.boaterSide) return
    if (this.state.loadingContacts) {
      return (
        <i className="fa-solid fa-spinner-third fa-spin text-muted waitlist-spinner my-3" />
      )
    } else {
      return (
        <WaitlistContactsTable
          activeContacts={this.state.activeContacts}
          archivedContacts={this.state.archivedContacts}
          archivedContactsPath={this.state.archivedContactsPath}
          name={this.state.name}
          email={this.state.email}
          phone={this.state.phone}
          selectContact={this.selectContact}
          selectContactBoat={this.selectContactBoat}
          isContactSelected={this.isContactSelected}
          isContactBoatSelected={this.isContactBoatSelected}
          state={this.state}
        />
      )
    }
  }

  renderEmailMarketing() {
    if (this.boaterSide && !isset(this.props.state.userId)) {
      return (
        <div>
          <FormGroup
            name="email_marketing"
            label="Join Dockwa's community for the latest news and updates."
            labelClassName="font-normal pl-1"
            inputType="checkbox"
            value={this.state.emailMarketing}
            onChange={this.toggleEmailMarketing}
            className="mb-4 mt-0 flex cursor-pointer pl-4"
          />
        </div>
      )
    }
  }

  showSpaceType() {
    if (!this.props.multiDockage) return
    return (
      <div className="form-group">
        <label htmlFor="preferredSpaceType"> Preferred Space Type</label>
        <select
          id="preferredSpaceType"
          className="form-control"
          value={this.state.spaceType}
          onChange={this.handleChangedEvent}
          name="spaceType"
        >
          <option value="dock_or_mooring">Dock or Mooring</option>
          <option value="dock">Dock</option>
          <option value="mooring">Mooring</option>
        </select>
      </div>
    )
  }

  renderValidationError() {
    if (this.state.invalidEmailUrl) {
      return (
        <div className="form-error-message mb-3">
          {this.state.validationMessage}{" "}
          <a className="text-link" href={this.state.invalidEmailUrl}>
            View existing contacts.
          </a>
        </div>
      )
    } else {
      return this.validator.customMessage(this.state.validationMessage, "mb-3")
    }
  }

  render() {
    return (
      <div className="waitlist-controller">
        {this.boaterSide && (
          <p>
            Waitlisted reservation requests are filled at the discretion of a
            marina based on their availability. {this.props.state.marinaName}{" "}
            will contact you if a space opens up that fits your needs.
          </p>
        )}
        <WaitlistContact
          state={this.state}
          changed={this.changed}
          selectContact={this.selectContact}
          isContactBoatSelected={this.isContactBoatSelected}
          selectContactBoat={this.selectContactBoat}
          validator={this.validator}
          boaterSide={this.boaterSide}
        />
        {this.contactsTable()}
        <hr />
        {this.lengthOverall()}
        <div className="row nested-row">
          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="firstDay">First Day</label>
              <div className="form-control-with-icon">
                <i className="fa-solid fa-calendar form-control-icon-left" />
                <DatePicker
                  id="firstDay"
                  setParentState={this.handleDatePickerFirstDay}
                  value={this.state.firstDay}
                  datesDisabled={[]}
                  clearBtn={true}
                  startDate={moment().format("L")}
                  endDate={
                    this.props.state ? this.props.state.marinaEndDate : null
                  }
                />
              </div>
              {this.validator.message(
                "firstDay",
                this.state.firstDay,
                "required"
              )}
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="lastDay">Last Day</label>
              <div className="form-control-with-icon">
                <i className="fa-solid fa-calendar form-control-icon-left" />
                <DatePicker
                  id="lastDay"
                  setParentState={this.handleDatePickerLastDay}
                  value={this.state.lastDay}
                  datesDisabled={[]}
                  clearBtn={true}
                  startDate={this.state.firstDay || moment().format("L")}
                  endDate={
                    this.props.state
                      ? moment(this.props.state.marinaEndDate, "L")
                          .add(1, "days")
                          .format("L")
                      : null
                  }
                />
              </div>
              {this.validator.message(
                "lastDay",
                this.state.lastDay,
                "required"
              )}
            </div>
          </div>
        </div>
        {this.showSpaceType()}
        <div className="form-group">
          <label htmlFor="specialRequest">Special Request</label>
          <textarea
            id="specialRequest"
            className="form-control"
            value={this.state.specialRequest}
            name="specialRequest"
            onChange={this.handleChangedEvent}
            placeholder="(optional, dock vs mooring preference, etc.)"
          />
          <div className="text-muted pt-1 italic">
            Special request will be visible to the customer.
          </div>
        </div>
        {this.renderValidationError()}
        {this.renderEmailMarketing()}
        <NextButton
          processing={this.state.processing}
          click={this.submit}
          icon="mr-3"
          text={this.boaterSide ? "Join the Waitlist" : "Add to Waitlist"}
          processingText="Adding to list..."
          btnClass="btn-danger"
        />
      </div>
    )
  }
}

WaitlistController.propTypes = {
  boaterSide: PropTypes.bool,
  lengthOverall: PropTypes.string,
  firstDay: PropTypes.string,
  lastDay: PropTypes.string,
  spaceType: PropTypes.string.isRequired,
  verticalConstraints: PropTypes.shape({
    height: PropTypes.number,
    depth: PropTypes.number,
  }).isRequired,
  multiDockage: PropTypes.bool,
  marinaSlug: PropTypes.string,
  state: PropTypes.object.isRequired,
  user: PropTypes.object,
  setHeader: PropTypes.func,
}

export default WaitlistController
